import type { MeResponse, PermissionCode } from "@cafegestor/shared";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { useActiveCompanyId } from "@cafegestor/client";
import { useAuth } from "./auth";

// empresa ativa: desde a A0 no cliente compartilhado (o mesmo do CaféGestor Vendedor)
export { useActiveCompanyId };

/** Usuário, empresas e permissões na empresa ativa (fonte: API). */
export function useMe() {
  const { status } = useAuth();
  const companyId = useActiveCompanyId();
  return useQuery({
    queryKey: ["me", companyId],
    queryFn: () => apiFetch<MeResponse>("/me"),
    enabled: status === "signed_in",
    staleTime: 60_000,
  });
}

/**
 * O menu e os botões usam isto só para ESCONDER o que não se pode fazer.
 * Quem decide de verdade é a API, em cada requisição.
 */
export function useCan() {
  const { data } = useMe();
  const perms = new Set(data?.activeCompany?.permissions ?? []);
  return (code: PermissionCode) => perms.has(code);
}
